/*
 * Copyright (c) 2024. Tooling Team
 */

import { Button } from "@uhg-abyss/web/ui/Button";
import PropTypes from "prop-types";

export default function BottomBarButtons(props) {
  return (
    <div>
      <div className="m-3">
        {!props.hideAddRow && (
          <Button
            className="me-2"
            isDisabled={props.disableAllActions || props.addDisabled}
            variant="outline"
            color="neutral"
            onClick={props.addRowOnClick}
          >
            Add Row
          </Button>
        )}
        <Button
          className="me-2"
          isDisabled={props.disableAllActions || props.editRowsDisabled}
          variant="outline"
          color="neutral"
          onClick={props.editRowsOnClick}
        >
          Edit Rows
        </Button>
        {!props.hideCloneRows && (
          <Button
            className="me-2"
            isDisabled={props.disableAllActions || props.editRowsDisabled}
            variant="outline"
            color="neutral"
            onClick={props.cloneRowsOnClick}
          >
            Clone Rows
          </Button>
        )}
        {!props.hideBulkDelete && (
          <Button
            className="me-2"
            isDisabled={props.disableAllActions || props.bulkDeleteDisabled}
            variant="outline"
            color="neutral"
            onClick={props.bulkDeleteOnClick}
          >
            Delete Rows
          </Button>
        )}
        {!props.hideBulkUpload && (
          <Button
            className="me-2"
            isDisabled={props.disableAllActions || props.bulkUploadDisabled}
            variant="outline"
            color="neutral"
            onClick={props.bulkUploadOnClick}
          >
            Bulk Upload
          </Button>
        )}
      </div>
      <div className="d-flex flex-grow-1 m-4">
        <div className="d-flex flex-grow-1 justify-content-end">
          <Button
            variant="outline"
            color="neutral"
            isDisabled={props.disableAllActions || props.draftDisabled}
            onClick={props.draftOnClick}
            className="me-2"
          >
            Save as Public Draft
          </Button>
          {(!props.reviewDisabled || props.publishDisabled) && (
            <Button
              variant="outline"
              color="neutral"
              onClick={() => props.handleUpdateMapStatus("REVIEW")}
              isDisabled={props.disableAllActions || props.reviewDisabled}
              className="me-2"
            >
              Submit for Review
            </Button>
          )}
          {!props.publishDisabled && (
            <Button
              variant="outline"
              color="neutral"
              isDisabled={props.disableAllActions || props.publishDisabled}
              onClick={() => props.handleUpdateMapStatus("DRAFT")}
              className="me-2"
            >
              Move to Draft
            </Button>
          )}
          <Button
            isDisabled={props.disableAllActions || props.publishDisabled}
            onClick={() => props.handleUpdateMapStatus("PUBLISHED")}
            className="green-button"
            variant="outline"
            color="neutral"
          >
            Publish Mapping
          </Button>
        </div>
      </div>
    </div>
  );
}

BottomBarButtons.propTypes = {
  addRowOnClick: PropTypes.func,
  editRowsOnClick: PropTypes.func,
  cloneRowsOnClick: PropTypes.func,
  bulkUploadOnClick: PropTypes.func,
  bulkDeleteOnClick: PropTypes.func,
  backOnClick: PropTypes.func,
  draftOnClick: PropTypes.func,
  draftDisabled: PropTypes.bool,
  reviewDisabled: PropTypes.bool,
  publishDisabled: PropTypes.bool,
  addDisabled: PropTypes.bool,
  editRowsDisabled: PropTypes.bool,
  bulkUploadDisabled: PropTypes.bool,
  bulkDeleteDisabled: PropTypes.bool,
  handleUpdateMapStatus: PropTypes.func,
  disableAllActions: PropTypes.bool,
  hideAddRow: PropTypes.bool,
  hideCloneRows: PropTypes.bool,
  hideBulkDelete: PropTypes.bool,
  hideBulkUpload: PropTypes.bool,
};
